import http from '../utils/http';
import { ccUtils as utils } from '@/common/Utils';
import { pick } from 'lodash';

export const defaultState = {
    entityName: 'venue',
    baseUrl: 'api/venues/',
    selectedVenue: {},
    selectedVenueInfo: {}
};

export const getters = {
    venueBillingId(state) {
        if (state.selectedVenueInfo) {
            return state.selectedVenueInfo.billingAccountId || '';
        }
        return '';
    },
    currentMso(state) {
        if (state.selectedVenue && state.selectedVenue.mso) {
            return state.selectedVenue.mso.identifier;
        }
        return '';
    },
    currentPartner(state) {
        if (state.selectedVenue && state.selectedVenue.partner) {
            return state.selectedVenue.partner.identifier;
        }
        return '';
    },
    currentVenue(state) {
        if (state.selectedVenue && state.selectedVenue.venue) {
            return state.selectedVenue.venue.identifier;
        }
        return '';
    }
};

export const mutations = {
    setSelectedVenue(state, venue) {
        state.selectedVenue = venue;
    },
    setSelectedVenueInfo(state, venueInfo) {
        state.selectedVenueInfo = venueInfo;
        if (venueInfo && venueInfo.name) {
            if (!venueInfo.icon) {
                state.selectedVenueInfo.icon = venueInfo.name + '.svg';
            } else {
                state.selectedVenueInfo.icon = '';
            }
        }
    }
};

export const actions = {
    saveSelectedVenue({ commit, getters, rootState }, venue) {
        console.log('calling saveSelectedVenue');
        commit('setSelectedVenue', venue);
        localStorage.setItem('selectedVenue', JSON.stringify(venue));
        http.setAuthInfo(
            rootState.authUser.userToken,
            getters['currentMso'],
            getters['currentPartner'],
            getters['currentVenue']
        );
    },
    clearSelectedVenue({ commit }) {
        console.log('calling clearSelectedVenue');
        commit('setSelectedVenue', null);
        localStorage.removeItem('selectedVenue');
    },
    fetchVenueInfo({ commit, dispatch, state }, fullRefresh = true) {
        console.log('calling fetchVenueInfo');
        return http
            .get(`${state.baseUrl}venueInfo`, {
                notifyError: false
            })
            .then(res => {
                commit('setSelectedVenueInfo', res.data);
            })
            .then(() => {
                if (fullRefresh) {
                    return dispatch('authUser/buildUserPermissions', null, {
                        root: true
                    });
                }
            })
            .then(() => {
                if (fullRefresh) {
                    return dispatch('buildDataEntityAbilities', null, {
                        root: true
                    });
                }
            })
            .then(() => {
                if (fullRefresh) {
                    dispatch('fetchVenueData');
                }
            })
            .catch(error => {
                console.log('---- error while fetching venue info.', error);
                return dispatch('clearSelectedVenue');
            });
    },
    fetchPmsStatus() {
        console.log('calling fetchPmsStatus');
        return http.get(`api/hawkeye/networkStatus`, {
            notifyError: false
        });
    },
    fetchVenueData({ dispatch }) {
        console.log('calling fetchVenueData');
        dispatch('spaces/fetchAllSpaces', {}, { root: true });
        dispatch('devices/fetchDeviceStatusSummary', {}, { root: true });
        dispatch('spaces/fetchSpaceStatusSummary', {}, { root: true });
        dispatch('channelMaps/fetchChannelMaps', {}, { root: true });
    },
    updateVenue({ dispatch, state }, { oldVenue, newVenue }) {
        console.log('calling updateVenue');
        const updatableFields = [
            'id',
            'title',
            'billingAccountId',
            'addr1',
            'addr2',
            'city',
            'state',
            'zip',
            'phone',
            'supportNumber',
            'supportEmail',
            'supportWebUrl',
            'rebootTime',
            'defaultPublicChannelMapId',
            'defaultPrivateChannelMapId'
        ];
        const venueDiff = utils.diffObject(
            pick(oldVenue, updatableFields),
            pick(newVenue, updatableFields)
        );
        if (venueDiff && Object.keys(venueDiff).length) {
            return http
                .patch(
                    `${state.baseUrl}venueInfo`,
                    utils.replaceEmptyStrings(
                        pick(newVenue, Object.keys(venueDiff))
                    ),
                    {
                        notifyRequestPending: false,
                        notifySuccess: false,
                        notifyError: false
                    }
                )
                .then(res => {
                    dispatch('fetchVenueInfo', false);
                    return res.data;
                });
        }
        return oldVenue;
    }
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
};
